import {ProductCollectionComponent} from "./ProductCollectionComponent";
import React from "react";
import {useSearchParams} from "react-router-dom";

export default function GlobalProvider() {
    console.log(window.location.pathname)

    const pathname = window.location.pathname; // "/mirsalari"
    const segment = pathname.split("/")[1];    // "mirsalari"

    const [searchParams] = useSearchParams();


    let catParam = searchParams.get('cat'); // e.g. "12,13,14"

    // ۱. دریافت پارامتر طبقات از URL
    const floorsParam = searchParams.get('market_floor_ids');
    const tableParam = searchParams.get('table_id');
    const initialCategories = catParam
        ? catParam.split(',').map(s => s.trim()).filter(Boolean)
        : [];

    // ۲. تبدیل رشته طبقات به آرایه (مانند دسته‌بندی‌ها)
    const initialFloors = floorsParam
        ? floorsParam.split(',').map(s => s.trim()).filter(Boolean)
        : [];

    return <ProductCollectionComponent id={segment}
                                       initialCategories={initialCategories}
                                       initialFloors={initialFloors}  // <-- پاس دادن به کامپوننت
                                       tableId={tableParam}/> // <-- پاس دادن به کامپوننت/>

}
